import { FOREGROUND_COLOR_HEX } from "./constants";

export function isDigit(char) {
  return /^\d$/.test(char);
}


/**
  * @param {import("kaplay").KAPLAYCtx} k,
  * @param {Function<void, void>} onFinish
  */
export function makeTransitionComps(k, onFinish, shrink = false) {

  const body = k.make([
    k.pos(k.center()),
    k.circle(shrink ? k.width() : 0),
    k.timer(),
    k.z(100),
    k.color(FOREGROUND_COLOR_HEX),
  ])

  if (!shrink) {
    body.tween(body.radius, k.width(), 1, (v) => {
      body.radius = v
    }, k.easings.easeInBack).then(() => {
      onFinish()
    })
  } else {
    body.tween(body.radius, 0, 1, (v) => {
      body.radius = v
    }, k.easings.easeInBack).then(() => {
      onFinish()
    })
  }

  return body
}

/**
 * @param {import("kaplay").KAPLAYCtx} k 
 * @param {number} max_star_count 
  */
export function generateStars(k, max_star_count, max_x, max_y) {
  for (let i = 0; i < max_star_count; i++) {
    const star = k.add([
      k.pos(k.rand(0, max_x), k.rand(0, max_y)),
      k.circle(k.rand(2, 4)),
      k.color(FOREGROUND_COLOR_HEX),
      k.z(-99),
      k.move(k.vec2(0, 1), k.rand(5, 10)),
      k.offscreen({ distance: 10 })
    ]);

    star.onExitScreen(() => {
      star.pos.y = -5
    })
  }
}
